<section
  class="ftm-card"
  [tabindex]="0"
  [class.selected]="selected">
  <mat-expansion-panel
    disabled
    (opened)="togglePanelState('opened')"
    (closed)="togglePanelState('closed')">
    <mat-expansion-panel-header>
      <div class="header tw-flex tw-items-center tw-gap-2">
        <div
          class="tile-radio tw-flex tw-shrink-0"
          [class.selected]="selected"></div>
        <mg-ftm-activity-img
          [bannerImage]="item.activity.bannerImage"
          [imagePath]="item.activity.imagePath"
          [aspectRatio]="1 / 1">
        </mg-ftm-activity-img>
        <mg-text
          *ngIf="item.activity.name"
          variant="header-sm"
          [numberOfLines]="2">
          {{ item.activity.name }}
        </mg-text>
        <mg-icon
          class="dropdown-arrow"
          iconName="mg-drop-down-arrow"
          [class.is-open]="(mobilePanelState$ | async) === 'opened'"
          (click)="accordion.toggle()"></mg-icon>
      </div>
    </mat-expansion-panel-header>
    <div class="ftm-card-body tw-flex tw-flex-column">
      <mg-text
        *ngIf="item.activity.description"
        variant="body-sm"
        spacing="1">
        {{ item.activity.description }}
      </mg-text>
      <ng-container
        *ngIf="item.activity.createdByPerson"
        [ngTemplateOutlet]="labeledDetailTemplate"
        [ngTemplateOutletContext]="{
          $implicit: MESSAGES.TEACHER,
          value: item.activity.createdByPerson.name
        }">
      </ng-container>
      <ng-container
        *ngIf="item.activity.location"
        [ngTemplateOutlet]="labeledDetailTemplate"
        [ngTemplateOutletContext]="{
          $implicit: MESSAGES.LOCATION,
          value: item.activity.location
        }">
      </ng-container>
      <ng-container
        *ngIf="item.instance"
        [ngTemplateOutlet]="labeledDetailTemplate"
        [ngTemplateOutletContext]="{
          $implicit: MESSAGES.SEATS_AVAILABLE,
          value: (item.instance | activityRegistered: true)
        }">
      </ng-container>
    </div>
  </mat-expansion-panel>
</section>

<ng-template
  #labeledDetailTemplate
  let-label
  let-value="value">
  <div class="tw-flex tw-justify-between tw-items-center">
    <mg-text
      variant="body-sm"
      color="surface-alt">
      {{ label }}
    </mg-text>
    <mg-text
      variant="body-sm"
      textAlign="right">
      {{ value }}
    </mg-text>
  </div>
</ng-template>
